import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

/**
 * Conferma di un cambio di stato del clinico (esclusione, forzatura della
 * partecipazione) con un motivo FACOLTATIVO in testo semplice. Si chiude con
 * { reason } (null se lasciato vuoto) alla conferma, senza valore se annullata.
 */
@Component({
  selector: 'app-modal-clinician-state-reason',
  templateUrl: './modal-clinician-state-reason.component.html',
  styleUrls: ['./modal-clinician-state-reason.component.scss'],
  standalone: false,
})
export class ModalClinicianStateReasonComponent {
  reason = '';

  constructor(
    public dialogRef: MatDialogRef<ModalClinicianStateReasonComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { titleKey: string; textKey: string; name: string },
  ) {}

  confirm(): void {
    this.dialogRef.close({ reason: this.reason.trim() || null });
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
